import React from 'react'
import './Mailer.css'

function Mailer() {
  return (
    <div className='containerborder'>
      <h1 className='contactheader'>Contact</h1>
      <h5>jonathan@jonathanroot.co.uk</h5>
      <h5>mobile: +44 (0)7768 292666</h5>
      <h5>instagram: <a href='https://www.instagram.com/jonathanroot' target='_blank' rel="noreferrer" className='eyevine'>@jonathanroot</a></h5>

    </div>
  )
}

export default Mailer